import React from 'react';
import classNames from 'classnames';
import './PCardContainer.scss';

function PCardContainer({ children, className, isDisabled }) {
  const classes = classNames({
    'pcard-container': true,
    'pcard-container--disabled': isDisabled,
  });
  return (
    <div className={`${classes} ${className}`}>
      {children}
    </div>
  );
}

export default PCardContainer;
